import { render } from "./GamesPop2.vue?vue&type=template&id=6a75c352"
import script from "./GamesPop2.vue?vue&type=script&lang=js"
export * from "./GamesPop2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__